import {useRequiredAuth} from '../stores/AuthStore'

// CampMinder employees log in with an @campminder.com address, so we treat that
// domain as the "internal user" signal for showing internal-only affordances
// (e.g. the "See Facial Recognition Confidence" photo action).
//
// This is a best-effort, CLIENT-SIDE VISIBILITY gate, NOT a security boundary:
// the faces recognition-attempts endpoint independently enforces the
// authoritative `campminderstaff` gate and returns 403 to non-staff callers, so
// this only decides whether the affordance is shown — it can never leak data.
// It is a tighter proxy for "CampMinder employee" than the multi-camp
// (clients > 1) heuristic, which also matched non-employee multi-camp admins.
//
// Fail-closed: a missing/blank email is treated as not-an-employee.
const CAMPMINDER_EMAIL_DOMAIN = '@campminder.com'

export const useIsCampMinderEmployee = (): boolean => {
  const {person} = useRequiredAuth()
  return (person.email ?? '')
    .trim()
    .toLowerCase()
    .endsWith(CAMPMINDER_EMAIL_DOMAIN)
}
